import React from 'react'
import Aboutme from '../Components/Aboutme/Aboutme'
import Footer from '../Components/Footer/Footer'
import Navbar from '../Components/Navbar'

const About = () => {
    return (
        <div>
            <Navbar/>
            <Aboutme/>
            <Footer/>
        </div>
    )
}

export default About
